/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type EventTransactionResponse = {
    /**
     * Transaction ID
     */
    id: string;
    /**
     * User ID
     */
    userId: string;
    /**
     * User display name
     */
    username: string;
    /**
     * 1=DAILY_LOGIN, 2=DEPOSIT, 3=CASE_OPEN, 4=GIVEAWAY_JOIN, 5=SPEND
     */
    actionType: EventTransactionResponse.actionType;
    /**
     * Human-readable action description
     */
    actionDescription: string;
    /**
     * Whale points awarded (positive) or spent (negative)
     */
    whalePoints: number;
    /**
     * Reference ID for the source action
     */
    referenceId?: string | null;
    /**
     * Reference type (e.g., case_opening, deposit)
     */
    referenceType?: string | null;
    /**
     * Additional transaction metadata
     */
    metadata?: Record<string, any> | null;
    /**
     * Transaction timestamp
     */
    createdAt: string;
};
export namespace EventTransactionResponse {
    /**
     * 1=DAILY_LOGIN, 2=DEPOSIT, 3=CASE_OPEN, 4=GIVEAWAY_JOIN, 5=SPEND
     */
    export enum actionType {
        '_1' = 1,
        '_2' = 2,
        '_3' = 3,
        '_4' = 4,
        '_5' = 5,
    }
}

